import { find, filter, keyBy } from 'lodash-unified';
import { IOption } from '@bg-shared/interfaces';
import { IGameOptions } from './interfaces';

export const gamesOptionsSelectors = {
    getItems: (state: IGameOptions) => state.items,

    getOptions: (state: IGameOptions) => state?.options,

    getOptionByClass: (optionClass: IOption['optionClass']) => (state: IGameOptions) =>
        find(state.options, { optionClass }),

    getOptionsByClasses: (optionClasses: IOption['optionClass'][]) => (state: IGameOptions) =>
        filter(Object.values(state.options), (item) => optionClasses.includes(item.optionClass)),

    getOptionsByKey: (key: string) => (state: IGameOptions) => keyBy(state.options, key),

    getMaxMultiplier: (optionClass: IOption['optionClass']) => (state: IGameOptions) => {
        const option = gamesOptionsSelectors.getOptionByClass(optionClass)(state);

        return Math.max(...option.multipliers.map((m) => m.multiplier));
    },
};
